<template>
  <!-- 费用方案维护 -->
  <div>
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :title="title"
      inline-message
      :width="$selectByLang('1000px', '1200px', '1200px', '1500px', '1500px', '1400px')"
    >
      <el-form
        ref="schemeMaintainForm"
        :model="schemeMaintainForm"
        :disabled="locked"
        :label-width="isZh ? '80px' : '100px'"
        label-position="left"
      >
        <el-row :gutter="10">
          <el-col :xs="7" :sm="7" :md="7">
            <el-form-item :label="$t('CargoMsg.Cargo_BusinessType')">
              <el-select
                v-model="schemeMaintainForm.lob"
                no="BusinessType"
                filterable
                :placeholder="$t('common.defaultPlaceholder')"
                @change="lobChangeHandler"
              >
                <el-option
                  v-for="item in lobArray"
                  :key="item.code"
                  :label="isZh ? item.chineseName :item.englishName"
                  :value="item.code"
                />
              </el-select>
              <!--              <cargo-advance-select-->
              <!--                filterable-->
              <!--                :clearable="false"-->
              <!--                :headers="[$t('Information.ChineseName2')]"-->
              <!--                :fields="['chineseName']"-->
              <!--                :callback-params="{key:'lob'}"-->
              <!--                callback-method-type="value"-->
              <!--                :default-value="schemeMaintainForm.lob"-->
              <!--                tag-value="code"-->
              <!--                :tag-name="isZh?'chineseName':'englishName'"-->
              <!--                :static-options="lobArray"-->
              <!--                :filter-tag-names="['chineseName']"-->
              <!--                @parentCallBack="lobChangeHandler"-->
              <!--              />-->
            </el-form-item>
          </el-col>
          <el-col :xs="7" :sm="7" :md="7">
            <el-form-item :label="$t('CargoMsg.Cargo_ProductName')">
              <el-input
                v-model="schemeMaintainForm.name"
                v-uppercase
                no="ProductName"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8">
            <el-form-item :label="$t('CargoMsg.Cargo_Department')">
              <el-select ref="departmentRef" v-model="schemeMaintainForm.departmentIdArr" no="Department" multiple @change="changeDepartment">
                <el-option
                  v-for="item in allDepartments"
                  :key="item.departmentId"
                  :value="item.departmentId"
                  :label="isZh?item.chineseName:item.englishName"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-button no="InverseSelect" @click="departmentReverseSelect">{{ $t('CargoMsg.Cargo_InverseSelect') }}</el-button>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="7" :sm="7" :md="7">
            <el-form-item :label="$t('CargoMsg.Cargo_TypeOfGoods')">
              <cargo-advance-select
                no="TypeOfGoods"
                filterable
                :clearable="false"
                :select-type="selectTypeNames.basic_data_CargoType"
                :callback-params="{key:'cargoType'}"
                callback-method-type="value"
                :default-value="schemeMaintainForm.cargoType"
                @parentCallBack="getSchemeMaintainValueFromChild"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="7" :sm="7" :md="7">
            <el-form-item :label="$t('CargoMsg.Cargo_FLCLType')">
              <el-select ref="FLclRef" v-model="schemeMaintainForm.containerLoadTypeArr" no="FLCLType" multiple @change="changeFLCL">
                <el-option
                  v-for="item in containerLoadTypes"
                  :key="item.code"
                  :value="item.code"
                  :label="isZh?item.chineseName:item.englishName"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="8" :sm="8" :md="8">
            <el-form-item :label="$t('CargoMsg.Cargo_DescriptionOfPlan')">
              <el-input
                v-model="schemeMaintainForm.remark"
                no="PlanDescription"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="7" :sm="7" :md="7">
            <el-form-item :label="$t('CargoMsg.Cargo_EffectiveDate')">
              <el-date-picker
                v-model="schemeMaintainForm.effectiveDate"
                no="EffectiveDate"
                type="date"
                style="width: 100%"
                :placeholder="$t('CargoMsg.Cargo_Select')+$t('CargoMsg.Cargo_EffectiveDate')"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="7" :sm="7" :md="7">
            <el-form-item :label="$t('CargoMsg.Cargo_InvalidDate')">
              <el-date-picker
                v-model="schemeMaintainForm.expiryDate"
                no="InvalidDate"
                type="date"
                style="width: 100%"
                :placeholder="$t('CargoMsg.Cargo_Select')+$t('CargoMsg.Cargo_InvalidDate')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-tabs
          v-if="innerVisible"
          v-model="activeTabName"
          type="card"
          style="width:100%;"
        >
          <el-tab-pane
            :label="$t('CargoMsg.Cargo_ChargeDetails')"
            name="dgSchemeDetail"
          >
            <de-scheme-detail ref="deSchemeDetail" :dg-scheme-detail-value="dgSchemeDetailValue" :lob="schemeMaintainForm.lob" :status="innerStatus" :locked="locked" :city-list-old="cityList" :sale-role-hide="saleRoleHide" @func="getDataFormDgSchemeDetail" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_PortOfLoading')"
            name="polGroup"
          >
            <group-tab ref="pol-group" :detail-value="polDetailValue" :status="innerStatus" :lob="schemeMaintainForm.lob" :is-need-change-port="isNeedChangePort" group-name="POL" :locked="locked" @func="getDataFormPolGroup" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_DestinationPort')"
            name="podGroup"
          >
            <group-tab ref="pod-group" :detail-value="podDetailValue" :status="innerStatus" :lob="schemeMaintainForm.lob" :is-need-change-port="isNeedChangePort" group-name="POD" :locked="locked" @func="getDataFormPodGroup" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_OverseaWarehouse')"
            name="owGroup"
          >
            <group-tab ref="ow-group" :detail-value="owDetailValue" :status="status" group-name="OVERSEA-WAREHOUSE" :locked="locked" @func="getDataFormOwGroup" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_HSCode')"
            name="hsCodeGroup"
          >
            <group-tab ref="hs-code-group" :detail-value="hsCodeDetailValue" :status="innerStatus" group-name="HSCODE" :locked="locked" @func="getDataFormHsCode" />
          </el-tab-pane>
          <el-tab-pane
            v-if="!saleRoleHide"
            :lazy="true"
            :label="$t('CargoMsg.Cargo_AuthorizedClient')"
            name="customerGroup"
          >
            <group-tab ref="customer-group" :detail-value="customerDetailValue" :status="innerStatus" group-name="CUSTOMER" :locked="locked" @func="getDataFormCustomer" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_Carrier')"
            name="carrierGroup"
          >
            <group-tab ref="carrier-group" :detail-value="carrierDetailValue" :status="innerStatus" group-name="CARRIER" :locked="locked" @func="getDataFormCarrier" />
          </el-tab-pane>
          <el-tab-pane
            v-if="!saleRoleHide"
            :lazy="true"
            :label="$t('CargoMsg.Cargo_BookingAgent')"
            name="bookingAgentGroup"
          >
            <group-tab ref="booking-agent-group" :detail-value="bookingAgentDetailValue" :status="innerStatus" group-name="BOOKING-AGENT" :locked="locked" @func="getDataFormBookingAgent" />
          </el-tab-pane>
          <el-tab-pane
            v-if="!saleRoleHide"
            :lazy="true"
            :label="$t('SeaExport.BillExchangeAgent')"
            name="exchangeAgentGroup"
          >
            <group-tab ref="exchange-agent-group" :detail-value="exchangeAgentDetailValue" :status="innerStatus" group-name="EXCHANGE-AGENT" :locked="locked" @func="getDataFormExchangeAgent" />
          </el-tab-pane>
          <el-tab-pane
            v-if="!saleRoleHide"
            :lazy="true"
            :label="$t('CargoMsg.Cargo_NominatedAgent')"
            name="designationAgentGroup"
          >
            <group-tab ref="designation-agent-group" :detail-value="designationAgentDetailValue" :status="innerStatus" group-name="DESIGNATION-AGENT" :locked="locked" @func="getDataFormDesignationAgent" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_ShippingRouteArea')"
            name="saGroup"
          >
            <group-tab ref="sa-group" :detail-value="saDetailValue" :status="innerStatus" group-name="SA" :locked="locked" @func="getDataFormSa" />
          </el-tab-pane>
          <el-tab-pane
            v-if="!saleRoleHide"
            :lazy="true"
            :label="$t('CargoMsg.Cargo_DestinationAgent')"
            name="destinationAgentGroup"
          >
            <group-tab ref="destination-agent-group" :detail-value="destinationAgentDetailValue" :status="innerStatus" group-name="DESTINATION-AGENT" :locked="locked" @func="getDataFormDestinationAgent" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_AvailableBranch')"
            name="branchGroup"
          >
            <group-tab ref="branch-group" :detail-value="branchDetailValue" :status="innerStatus" group-name="BRANCH" :locked="locked" @func="getDataFormBranchCode" />
          </el-tab-pane>
          <el-tab-pane
            :lazy="true"
            :label="$t('CargoMsg.Cargo_User')"
            name="userGroup"
          >
            <group-tab ref="user-group" :detail-value="userDetailValue" :status="innerStatus" group-name="USER" :locked="locked" @func="getDataFormUserCode" />
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer">
        <span style="position: absolute; left: 20px;">
          <!--复制新增-->
          <el-button v-show="!isNew" no="CopyAndAddPoItems" :disabled="locked" type="primary" @click="copyHandler">{{ $t('CargoMsg.Cargo_CopyAndAddPoItems') }}</el-button>
          <!--费用导出-->
          <el-button no="ExportExpenses" type="primary" @click="exportHandler">{{ $t('CargoMsg.Cargo_ExportExpenses') }}</el-button>
        </span>
        <span style="padding-right: 5px;">
          <!--确定/取消-->
          <el-button no="confirm" :disabled="locked" type="primary" @click="submitCostPlan">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
    <business-copy-window
      v-show="copyDialog.visible"
      ref="costPlanCopyWindow"
      source="COST_PLAN"
      :visible.sync="copyDialog.visible"
      @confirmCallBack="copyDialog.confirmCallBackHandler"
    />
  </div>
</template>

<script>
import deSchemeDetail from '@/views/cargo/v0/Information/components/costPlan/dgSchemeDetail'
import groupTab from '@/views/cargo/v0/Information/components/costPlan/groupTab'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { addCostPlan, getCostPlanDetail, updateCostPlan } from '@/api/costPlan'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { dateCompare } from '@/utils/commonUtil'
import StrUtils from '@/utils/StrUtils'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import { getLocationList } from '@/api/location'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import BusinessCopyWindow from '@/components/Cargo/Job/businessCopyWindow.vue'

export default {
  name: 'ChargeSchemeDialog',
  components: { BusinessCopyWindow, cargoAdvanceSelect, deSchemeDetail, groupTab },
  props: {
    visible: { type: Boolean, required: true },
    context: { type: Object, required: true },
    status: { type: String, required: true },
    locked: { type: Boolean, required: true },
    chargeScheme: { type: Object, default: null },
    saleRoleHide: { type: Boolean, default: false } // 子应用销售角色
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      url: URL,
      copyDialog: {
        visible: false,
        confirmCallBackHandler: () => {
          this.copySchemeHandler()
        }
      },
      schemeMaintainForm: {
        uuid: '',
        version: '',
        lob: '',
        fba: '',
        name: '',
        customerId: '',
        carrierId: '',
        bookingAgent: '',
        region: '',
        cargoType: '',
        destinationAgent: '',
        effectiveDate: '',
        expiryDate: '',
        remark: '',
        branchId: '',
        containerLoadTypeArr: [],
        departmentIdArr: [],
        approvedState: 0
      },
      allCompanyList: [],
      carrierCompanyList: [],
      originContainerLoadTypeArr: [],
      originDepartmentIdArr: [],
      lobArray: [],
      allDepartments: [],
      cityList: [],
      activeTabName: 'dgSchemeDetail',
      // 该数组维护新增&维护方案弹窗页费用明细项
      dgSchemeDetail: [],
      // ====> 以下四个数组分别收集新增&维护方案弹窗页除费用明细外四个tab下的表格值,维护对应费用条件
      schemeCriteriaPolList: [],
      schemeCriteriaPoDList: [],
      schemeCriteriaOwList: [],
      schemeCriteriaUserList: [],
      schemeCriteriaBranchList: [],
      schemeCriteriaHsCodeList: [],
      schemeCriteriaCustomerList: [],
      schemeCriteriaCarrierList: [],
      schemeCriteriaBookingAgentList: [],
      schemeCriteriaSaList: [],
      schemeCriteriaDestinationAgentList: [],
      schemeCriteriaExchangeAgentList: [],
      schemeCriteriaDesignationAgentList: [],
      // <====
      dgSchemeDetailValue: [],
      polDetailValue: [],
      podDetailValue: [],
      owDetailValue: [],
      userDetailValue: [],
      branchDetailValue: [],
      hsCodeDetailValue: [],
      customerDetailValue: [],
      carrierDetailValue: [],
      bookingAgentDetailValue: [],
      saDetailValue: [],
      destinationAgentDetailValue: [],
      exchangeAgentDetailValue: [],
      designationAgentDetailValue: [],
      isCopy: false,
      innerStatus: 'add',
      seaLobArray: ['', 'IE', 'SE', 'SI', 'FBA_SE'],
      airLobArray: ['AE', 'AI', 'FBA_AE'],
      railLobArray: ['RE', 'RI', 'FBA_RE'],
      isNeedChangePort: false,
      previousValue: ''
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    containerLoadTypes() {
      let lob
      if (this.schemeMaintainForm.lob) {
        if (this.schemeMaintainForm.lob === 'FBA_SE') {
          lob = 'SE'
        } else if (this.schemeMaintainForm.lob === 'FBA_AE') {
          lob = 'AE'
        } else if (this.schemeMaintainForm.lob === 'FBA_RE') {
          lob = 'RE'
        } else {
          lob = this.schemeMaintainForm.lob
        }
      }
      return ChargeUtils.getCargoType(lob)
    },
    isNew() {
      return !this.schemeMaintainForm.uuid
    },
    title() {
      const op = this.innerStatus === 'edit' ? this.$t('CargoMsg.Cargo_Edit') : this.$t('CargoMsg.Cargo_New')
      return op + ' ' + this.$t('SeaExport.ChangeSchema')
    },
    carrierMethodParams() {
      switch (this.schemeMaintainForm.lob) {
        case 'SE':
        case 'SI':
          return { seaCmp: true, airCmp: false }
        case 'AE':
        case 'AI':
          return { seaCmp: false, airCmp: true }
        case 'RE':
          return { companyLob: 'railwayExport', portAgent: true, active: true }
        default:
          return {}
      }
    }
  },
  watch: {
    async visible(val) {
      if (val) {
        this.innerStatus = this.status
        await this.initBasicData()
        // 必须在innerVisible赋值前执行，否则费用明细列表显示空白
        await this.onshow()
        this.$nextTick(() => {
          this.convertTextDepartment()
          this.convertTextFLCL()
        })
      }
      this.innerVisible = val
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.resetDialog()
      } else {
        // 必须在显示之后执行，否则$refs取不到
        if (this.innerStatus === 'copy') {
          this.copySchemeHandler()
          // 部门选择全部
          // this.schemeMaintainForm.departmentIdArr = this.allDepartments.map(department => department.departmentId)
        }
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    this.lobArray = [...SystemConstants.CHARGE_SCHEME_LOBS]
    this.cityList = await getLocationList({}).then((res) => {
      return res.data.list || []
    })
    await this.initBasicData()
  },
  methods: {
    async onshow() {
      if (!['add', 'edit', 'copy'].includes(this.innerStatus)) {
        this.innerVisible = false
        return
      }
      if (this.innerStatus === 'add') {
        this.previousValue = ''
        // 部门全选
        this.schemeMaintainForm.departmentIdArr = this.allDepartments.map(department => department.departmentId)
        // CARGO-30754 兰高13855：费用方案区分分公司
        const defaultBranch = [{
          criteriaType: 13,
          criteriaValue: this.$store.getters.currentOfficeId,
          waitDealStatus: 'add'
        }]
        this.branchDetailValue = [...defaultBranch]
        this.schemeCriteriaBranchList = [...defaultBranch]
        return
      }
      const self = this
      self.loading = getLoading()
      await getCostPlanDetail(this.chargeScheme.uuid).then(res => {
        Object.assign(self.schemeMaintainForm, this.chargeScheme)
        this.previousValue = self.schemeMaintainForm.lob
        self.activeTabName = 'dgSchemeDetail'
        // 解析出费用明细列表
        const schemeDetail = res.data['schemeDetail']
        // CARGO-31003 在新增费用时，直接对特定的费用进行受控
        for (const detail of schemeDetail) {
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', detail.chargeItemId)
          detail.controlled = chargeItem?.controlled
          detail.needInvoice = chargeItem?.needInvoice
        }
        // 解析出费用条件列表
        const schemeCriteria = res.data['schemeCriteria']
        // 整拼类型
        const containerLoadTypeSchemeCriteria = schemeCriteria.filter(item => item['criteriaType'] === 1)
        this.originContainerLoadTypeArr = [...containerLoadTypeSchemeCriteria]
        if (containerLoadTypeSchemeCriteria) {
          for (const schemeCriterionTem of containerLoadTypeSchemeCriteria) {
            for (const containerLoadType of this.containerLoadTypes) {
              if (String(containerLoadType.code) === schemeCriterionTem.criteriaValue) {
                this.schemeMaintainForm.containerLoadTypeArr.push(containerLoadType.code)
                break
              }
            }
          }
        }
        // 部门
        const departmentSchemeCriteria = schemeCriteria.filter(item => item['criteriaType'] === 2)
        this.originDepartmentIdArr = departmentSchemeCriteria
        if (departmentSchemeCriteria) {
          for (const departmentSchemeCriterion of departmentSchemeCriteria) {
            for (const department of this.allDepartments) {
              if (department.departmentId === Number(departmentSchemeCriterion.criteriaValue)) {
                this.schemeMaintainForm.departmentIdArr.push(department.departmentId)
                break
              }
            }
          }
        }
        // 费用条件-起运港
        const polDetail = schemeCriteria.filter(item => item['criteriaType'] === 3)
        // 费用条件-目标港
        const podDetail = schemeCriteria.filter(item => item['criteriaType'] === 4)
        // 费用条件-海外仓
        const owDetail = schemeCriteria.filter(item => item['criteriaType'] === 12)
        // 费用条件-用户
        const userDetail = schemeCriteria.filter(item => item['criteriaType'] === 6)
        // 费用条件-可用分公司
        const branchDetail = schemeCriteria.filter(item => item['criteriaType'] === 13)
        if (this.innerStatus === 'copy' && branchDetail.length <= 0) {
          branchDetail.push({
            criteriaType: 13,
            criteriaValue: this.$store.getters.currentOfficeId,
            waitDealStatus: 'add'
          })
        }
        // 费用条件-hsCode
        const hsCodeDetail = schemeCriteria.filter(item => item['criteriaType'] === 5)

        // 委托单位
        const customerDetail = schemeCriteria.filter(item => item['criteriaType'] === 7)
        // 承运人
        const carrierDetail = schemeCriteria.filter(item => item['criteriaType'] === 8)
        // 订舱代理
        const bookingAgentDetail = schemeCriteria.filter(item => item['criteriaType'] === 9)
        // 航线/区域
        const saDetail = schemeCriteria.filter(item => item['criteriaType'] === 10)
        // 目的港代理
        const destinationAgentDetail = schemeCriteria.filter(item => item['criteriaType'] === 11)
        // 换单代理
        const exchangeAgentDetail = schemeCriteria.filter(item => item['criteriaType'] === 14)
        // 指定货代理
        const designationAgentDetail = schemeCriteria.filter(item => item['criteriaType'] === 15)

        // 1. 分别为负责传值给子组件的xxxValue变量赋值 2. 分别为存储最终结果的各项xxxList变量赋值
        self.dgSchemeDetailValue = [...schemeDetail]
        self.dgSchemeDetail = [...schemeDetail]
        self.polDetailValue = [...polDetail]
        self.schemeCriteriaPolList = [...polDetail]
        self.podDetailValue = [...podDetail]
        self.schemeCriteriaPoDList = [...podDetail]
        self.owDetailValue = [...owDetail]
        self.schemeCriteriaOwList = [...owDetail]
        self.userDetailValue = [...userDetail]
        self.schemeCriteriaUserList = [...userDetail]
        self.branchDetailValue = [...branchDetail]
        self.schemeCriteriaBranchList = [...branchDetail]
        self.hsCodeDetailValue = [...hsCodeDetail]
        self.schemeCriteriaHsCodeList = [...hsCodeDetail]
        self.schemeCriteriaCustomerList = [...customerDetail]
        self.customerDetailValue = [...customerDetail]
        self.schemeCriteriaCarrierList = [...carrierDetail]
        self.carrierDetailValue = [...carrierDetail]
        self.schemeCriteriaBookingAgentList = [...bookingAgentDetail]
        self.bookingAgentDetailValue = [...bookingAgentDetail]
        self.schemeCriteriaSaList = [...saDetail]
        self.saDetailValue = [...saDetail]
        self.schemeCriteriaDestinationAgentList = [...destinationAgentDetail]
        self.destinationAgentDetailValue = [...destinationAgentDetail]
        self.schemeCriteriaExchangeAgentList = [...exchangeAgentDetail]
        self.exchangeAgentDetailValue = [...exchangeAgentDetail]
        self.schemeCriteriaDesignationAgentList = [...designationAgentDetail]
        self.designationAgentDetailValue = [...designationAgentDetail]
        this.isCopy = false
      }).finally(
        self.loading.close()
      )
    },
    getSchemeMaintainValueFromChild(obj) {
      this.schemeMaintainForm[obj.key] = obj.value
    },
    getDataFormDgSchemeDetail(data) {
      if (this.isCopy) {
        this.schemeMaintainForm.schemeDetail = [...data]
      } else {
        this.dgSchemeDetail = [...data]
      }
    },
    getDataFormPolGroup(data) {
      this.schemeCriteriaPolList = [...data]
    },
    getDataFormPodGroup(data) {
      this.schemeCriteriaPoDList = [...data]
    },
    getDataFormOwGroup(data) {
      this.schemeCriteriaOwList = [...data]
    },
    getDataFormUserCode(data) {
      this.schemeCriteriaUserList = [...data]
    },
    getDataFormBranchCode(data) {
      this.schemeCriteriaBranchList = [...data]
    },
    getDataFormHsCode(data) {
      this.schemeCriteriaHsCodeList = [...data]
    },
    getDataFormCustomer(data) {
      this.schemeCriteriaCustomerList = [...data]
    },
    getDataFormCarrier(data) {
      this.schemeCriteriaCarrierList = [...data]
    },
    getDataFormBookingAgent(data) {
      this.schemeCriteriaBookingAgentList = [...data]
    },
    getDataFormSa(data) {
      this.schemeCriteriaSaList = [...data]
    },
    getDataFormDestinationAgent(data) {
      this.schemeCriteriaDestinationAgentList = [...data]
    },
    getDataFormExchangeAgent(data) {
      this.schemeCriteriaExchangeAgentList = [...data]
    },
    getDataFormDesignationAgent(data) {
      this.schemeCriteriaDesignationAgentList = [...data]
    },
    // 费用条件数据组合
    schemeCriteriaList() {
      return [
        ...this.schemeCriteriaPolList,
        ...this.schemeCriteriaPoDList,
        ...this.schemeCriteriaOwList,
        ...this.schemeCriteriaUserList,
        ...this.schemeCriteriaBranchList,
        ...this.schemeCriteriaHsCodeList,
        ...this.schemeCriteriaCustomerList,
        ...this.schemeCriteriaCarrierList,
        ...this.schemeCriteriaBookingAgentList,
        ...this.schemeCriteriaSaList,
        ...this.schemeCriteriaDestinationAgentList,
        ...this.schemeCriteriaExchangeAgentList,
        ...this.schemeCriteriaDesignationAgentList
      ]
    },
    // 提交费用方案
    async submitCostPlan() {
      // 校验费用明细
      if (!await this.$refs.deSchemeDetail.checkAddRow()) {
        return
      }
      // 校验费用方案表单
      if (!this.toCheckCostPlanForm(this.schemeMaintainForm)) {
        return
      }
      const schemeCriteriaVOList = this.schemeCriteriaList()
      // 部门/整拼类型处理
      schemeCriteriaVOList.push(...this.executeDepartmentIdArr())
      schemeCriteriaVOList.push(...this.executeContainerLoadTypeArr())
      let dgSchemeDetail = this.dgSchemeDetail
      if (this.isCopy) {
        dgSchemeDetail = this.schemeMaintainForm.schemeDetail
      }
      if (this.schemeMaintainForm.lob === 'FBA_SE') {
        this.schemeMaintainForm.lob = 'SE'
        this.schemeMaintainForm.fba = true
      }
      if (this.schemeMaintainForm.lob === 'FBA_AE') {
        this.schemeMaintainForm.lob = 'AE'
        this.schemeMaintainForm.fba = true
      }
      if (this.schemeMaintainForm.lob === 'FBA_RE') {
        this.schemeMaintainForm.lob = 'RE'
        this.schemeMaintainForm.fba = true
      }
      // 组建请求数据
      const params = {
        ...this.schemeMaintainForm,
        schemeDetailVOList: dgSchemeDetail,
        schemeCriteriaVOList
      }
      params.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading()
      if (this.innerStatus === 'edit') {
        await updateCostPlan(params).then(res => {
          this.innerVisible = false
          this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
          this.context.fetchCostPlanList()
        }).finally(() => loading.close())
      } else {
        await addCostPlan(params).then(res => {
          this.innerVisible = false
          this.$message({ message: this.$t('common.tips.saveSuccess'), type: 'success' })
          this.context.fetchCostPlanList()
        }).finally(() => loading.close())
      }
    },
    // 检查费用表单
    toCheckCostPlanForm(opt) { // opt=> add,edit
      const { lob, name } = opt
      let errorMsg = ''
      errorMsg += !lob ? this.$t('CargoMsg.Cargo_PleaseSelectBusinessType') + ',' : ''
      errorMsg += !name ? this.$t('CargoMsg.Cargo_PleaseEnterPlanName') + ',' : ''
      const existDetail = this.dgSchemeDetail.length > 0 || this.$refs.deSchemeDetail.rowData.length > 0
      errorMsg += !existDetail ? this.$t('CargoMsg.Cargo_PleaseEnterExpenseDetails') + ',' : ''
      if (this.schemeMaintainForm.effectiveDate && this.schemeMaintainForm.expiryDate) {
        errorMsg += dateCompare(this.schemeMaintainForm.effectiveDate, this.schemeMaintainForm.expiryDate) >= 0 ? this.$t('CargoMsg.Cargo_EffectiveDateMustBeLessThanTheExpirationDate') + ',' : ''
      }
      for (const element of this.dgSchemeDetail) {
        if (element.chargeItemId === 0) {
          errorMsg += this.$t('CargoMsg.Cargo_PleaseEnterExpenseDescription')
          break
        }
        if (element.measure === ChargeMeasure.BY_CNTR_CHARGE_MEASURE.code && StrUtils.isEmpty(element.eqSize) && StrUtils.isEmpty(element.eqType)) {
          errorMsg += this.$t('CargoMsg.Cargo_PleaseEnterBoxTypeOrBoxType')
          break
        }
      }
      if (errorMsg && errorMsg.endsWith(',')) {
        errorMsg = errorMsg.substring(0, errorMsg.length - 1)
      }
      if (!errorMsg) {
        return true
      }
      this.$message.error(errorMsg)
      return false
    },
    // 部门反选
    departmentReverseSelect() {
      // 循环反选
      const arr = []
      for (const department of this.allDepartments) {
        if (!this.schemeMaintainForm.departmentIdArr.includes(department.departmentId)) {
          arr.push(department.departmentId)
        }
      }
      this.schemeMaintainForm.departmentIdArr = arr
      this.convertTextDepartment()
    },
    resetDialog() {
      this.isCopy = false
      this.originContainerLoadTypeArr = []
      this.originDepartmentIdArr = []
      // 该数组维护新增&维护方案弹窗页费用明细项
      this.dgSchemeDetail = []
      // ====> 以下四个数组分别收集新增&维护方案弹窗页除费用明细外四个tab下的表格值维护对应费用条件
      this.schemeCriteriaPolList = []
      this.schemeCriteriaPoDList = []
      this.schemeCriteriaOwList = []
      this.schemeCriteriaUserList = []
      this.schemeCriteriaBranchList = []
      this.schemeCriteriaHsCodeList = []
      // <====
      this.dgSchemeDetailValue = []
      this.polDetailValue = []
      this.podDetailValue = []
      this.owDetailValue = []
      this.userDetailValue = []
      this.branchDetailValue = []
      this.hsCodeDetailValue = []
      this.resetForm()
      this.innerStatus = 'add'
    },
    resetForm() {
      this.schemeMaintainForm = {
        uuid: '',
        version: '',
        lob: '',
        name: '',
        fba: '',
        customerId: '',
        carrierId: '',
        bookingAgent: '',
        region: '',
        cargoType: '',
        destinationAgent: '',
        effectiveDate: '',
        expiryDate: '',
        remark: '',
        branchId: '',
        containerLoadTypeArr: [],
        departmentIdArr: [],
        approvedState: 0
      }
      this.convertTextFLCL()
      this.convertTextDepartment()
    },
    copyHandler() {
      // CARGO-31454 费用方案进行复制新增时，增加复制条件
      const ifNotShowDialog = LocalStorageUtilsNew.getConfiguration('COPY_COST_PLAN')
      if (ifNotShowDialog !== true) {
        this.copyDialog.visible = true
      } else {
        this.copySchemeHandler()
      }
    },
    // 复制新增
    copySchemeHandler() {
      this.$emit('update:status', 'copy')
      this.isCopy = true
      const pol = LocalStorageUtilsNew.getConfiguration('COPY_POL_COST_PLAN')
      const pod = LocalStorageUtilsNew.getConfiguration('COPY_POD_COST_PLAN')
      const overseaWarehouse = LocalStorageUtilsNew.getConfiguration('COPY_OVERSEA_WAREHOUSE_COST_PLAN')
      const hsCode = LocalStorageUtilsNew.getConfiguration('COPY_HS_CODE_COST_PLAN')
      const customer = LocalStorageUtilsNew.getConfiguration('COPY_CUSTOMER_COST_PLAN')
      const carrier = LocalStorageUtilsNew.getConfiguration('COPY_CARRIER_COST_PLAN')
      const bookingAgent = LocalStorageUtilsNew.getConfiguration('COPY_BOOKING_AGENT_COST_PLAN')
      const sa = LocalStorageUtilsNew.getConfiguration('COPY_SA_COST_PLAN')
      const destinationAgent = LocalStorageUtilsNew.getConfiguration('COPY_DESTINATION_AGENT_COST_PLAN')
      const availableBranch = LocalStorageUtilsNew.getConfiguration('COPY_AVAILABLE_BRANCH_COST_PLAN')
      const user = LocalStorageUtilsNew.getConfiguration('COPY_USER_COST_PLAN')
      const exchangeAgent = LocalStorageUtilsNew.getConfiguration('COPY_EXCHANGE_AGENT_COST_PLAN')
      const designationAgent = LocalStorageUtilsNew.getConfiguration('COPY_DESIGNATION_AGENT_COST_PLAN')
      const polDetail = this.polDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const podDetail = this.podDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const owDetail = this.owDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const userDetail = this.userDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      let branchDetail = this.branchDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const hsCodeDetail = this.hsCodeDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const customerDetail = this.customerDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const carrierDetail = this.carrierDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const bookingAgentDetail = this.bookingAgentDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const saDetail = this.saDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const destinationAgentDetail = this.destinationAgentDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const exchangeAgentDetail = this.exchangeAgentDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      const designationAgentDetail = this.designationAgentDetailValue.map(e => { return { criteriaType: e.criteriaType, criteriaValue: e.criteriaValue, waitDealStatus: 'add' } })
      // 清空tab页
      this.polDetailValue = []
      this.schemeCriteriaPolList = []
      this.podDetailValue = []
      this.schemeCriteriaPoDList = []
      this.owDetailValue = []
      this.schemeCriteriaOwList = []
      this.userDetailValue = []
      this.schemeCriteriaUserList = []
      this.branchDetailValue = []
      this.schemeCriteriaBranchList = []
      this.hsCodeDetailValue = []
      this.schemeCriteriaHsCodeList = []
      this.customerDetailValue = []
      this.schemeCriteriaCustomerList = []
      this.carrierDetailValue = []
      this.schemeCriteriaCarrierList = []
      this.bookingAgentDetailValue = []
      this.schemeCriteriaBookingAgentList = []
      this.saDetailValue = []
      this.schemeCriteriaSaList = []
      this.destinationAgentDetailValue = []
      this.schemeCriteriaDestinationAgentList = []
      this.exchangeAgentDetailValue = []
      this.schemeCriteriaExchangeAgentList = []
      this.designationAgentDetailValue = []
      this.schemeCriteriaDesignationAgentList = []
      if (pol) {
        this.polDetailValue = [...polDetail]
        this.schemeCriteriaPolList = [...polDetail]
      }
      if (pod) {
        this.podDetailValue = [...podDetail]
        this.schemeCriteriaPoDList = [...podDetail]
      }
      if (overseaWarehouse) {
        this.owDetailValue = [...owDetail]
        this.schemeCriteriaOwList = [...owDetail]
      }
      if (user) {
        this.userDetailValue = [...userDetail]
        this.schemeCriteriaUserList = [...userDetail]
      }
      if (availableBranch) {
        if (branchDetail.length <= 0) {
          branchDetail.push({
            criteriaType: 13,
            criteriaValue: this.$store.getters.currentOfficeId,
            waitDealStatus: 'add'
          })
        }
      } else {
        branchDetail = [{
          criteriaType: 13,
          criteriaValue: this.$store.getters.currentOfficeId,
          waitDealStatus: 'add'
        }]
      }
      this.branchDetailValue = [...branchDetail]
      this.schemeCriteriaBranchList = [...branchDetail]
      if (hsCode) {
        this.hsCodeDetailValue = [...hsCodeDetail]
        this.schemeCriteriaHsCodeList = [...hsCodeDetail]
      }
      if (customer) {
        this.schemeCriteriaCustomerList = [...customerDetail]
        this.customerDetailValue = [...customerDetail]
      }
      if (carrier) {
        this.schemeCriteriaCarrierList = [...carrierDetail]
        this.carrierDetailValue = [...carrierDetail]
      }
      if (bookingAgent) {
        this.schemeCriteriaBookingAgentList = [...bookingAgentDetail]
        this.bookingAgentDetailValue = [...bookingAgentDetail]
      }
      if (sa) {
        this.schemeCriteriaSaList = [...saDetail]
        this.saDetailValue = [...saDetail]
      }
      if (destinationAgent) {
        this.schemeCriteriaDestinationAgentList = [...destinationAgentDetail]
        this.destinationAgentDetailValue = [...destinationAgentDetail]
      }
      if (exchangeAgent) {
        this.schemeCriteriaExchangeAgentList = [...exchangeAgentDetail]
        this.exchangeAgentDetailValue = [...exchangeAgentDetail]
      }
      if (designationAgent) {
        this.schemeCriteriaDesignationAgentList = [...designationAgentDetail]
        this.designationAgentDetailValue = [...designationAgentDetail]
      }
      // 复制
      this.schemeMaintainForm.schemeDetail = this.dgSchemeDetailValue
      this.schemeMaintainForm.branchId = this.$store.getters.currentOfficeId
      this.schemeMaintainForm.inputBy = this.$store.getters.userId
      this.schemeMaintainForm = ChargeUtils.copyChargeScheme(this.schemeMaintainForm)
      this.originDepartmentIdArr = []
      this.originContainerLoadTypeArr = []
      // 费用明细页签刷新
      this.dgSchemeDetail = [...this.schemeMaintainForm.schemeDetail]
      this.dgSchemeDetailValue = [...this.schemeMaintainForm.schemeDetail]
      this.schemeMaintainForm.schemeDetail = this.dgSchemeDetailValue
      this.innerStatus = 'copy'
      // if (this.$refs.deSchemeDetail) {
      //   this.$refs.deSchemeDetail.dgSchemeDetailValue = this.schemeMaintainForm.schemeDetail
      //   this.$refs.deSchemeDetail.refresh()
      // }
    },
    // 部门 保存前特殊处理
    executeDepartmentIdArr() {
      const nowData = []
      for (const element of this.schemeMaintainForm.departmentIdArr) {
        // 原始部门中有值则取出uuid、criteriaValue
        const data = this.originDepartmentIdArr.find(params => Number(params.criteriaValue) === element)
        if (data) {
          data.criteriaValue = Number(data.criteriaValue)
          nowData.push(data)
        } else {
          nowData.push({ criteriaValue: element })
        }
      }
      return this.notifyParent(this.originDepartmentIdArr, nowData, 2)
    },
    // 整拼类型 保存前特殊处理
    executeContainerLoadTypeArr() {
      const nowData = []
      for (const element of this.schemeMaintainForm.containerLoadTypeArr) {
        // 原始部门中有值则取出uuid、criteriaValue
        const data = this.originContainerLoadTypeArr.find(params => params.criteriaValue === element)
        if (data) {
          nowData.push(data)
        } else {
          nowData.push({ criteriaValue: element })
        }
      }
      return this.notifyParent(this.originContainerLoadTypeArr, nowData, 1)
    },
    // 筛选出新增&和删除项
    notifyParent(originData, nowData, criteriaType) {
      let addRow = []
      if (nowData && nowData.length > 0) {
        if (originData && originData.length > 0) {
          addRow = nowData.filter(row => {
            const rows = originData.filter(originRow => {
              return originRow.criteriaValue === row.criteriaValue
            })
            return rows.length < 1
          })
        } else {
          addRow = [...nowData]
        }
      }
      let delRow = []
      if (originData && originData.length > 0) {
        if (nowData && nowData.length > 0) {
          delRow = originData.filter(originRow => {
            const rows = nowData.filter(row => {
              return originRow.criteriaValue === row.criteriaValue
            })
            return rows.length < 1
          })
        } else {
          delRow = originData
        }
      }
      const rows = []
      addRow.forEach(row => {
        rows.push({
          criteriaType: criteriaType,
          criteriaValue: row.criteriaValue,
          waitDealStatus: 'add'
        })
      })
      delRow.forEach(row => {
        rows.push({
          uuid: row.uuid,
          criteriaType: criteriaType,
          criteriaValue: row.criteriaValue,
          waitDealStatus: 'delete'
        })
      })
      return rows
    },
    exportHandler() {
      this.$refs.deSchemeDetail.exportHandler()
    },
    async lobChangeHandler(value) {
      let poflag = false
      if (this.schemeCriteriaPolList && this.schemeCriteriaPolList.length > 0) {
        this.schemeCriteriaPolList.forEach(item => {
          if ((item.uuid && item.waitDealStatus !== 'delete') || item.waitDealStatus === 'add') {
            poflag = true
            return
          }
        })
      }
      if (this.schemeCriteriaPoDList && this.schemeCriteriaPoDList.length > 0) {
        this.schemeCriteriaPoDList.forEach(item => {
          if ((item.uuid && item.waitDealStatus !== 'delete') || item.waitDealStatus === 'add') {
            poflag = true
            return
          }
        })
      }
      this.isNeedChangePort = false
      let flag = false
      if (poflag && !((this.seaLobArray.indexOf(this.previousValue) > -1 && this.seaLobArray.indexOf(this.schemeMaintainForm.lob) > -1) ||
        (this.airLobArray.indexOf(this.previousValue) > -1 && this.airLobArray.indexOf(this.schemeMaintainForm.lob) > -1) ||
        (this.railLobArray.indexOf(this.previousValue) > -1 && this.railLobArray.indexOf(this.schemeMaintainForm.lob) > -1))) {
        await this.$confirm(this.$t('CargoMsg.Cargo_Lob_NEQ_Port'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning',
          closeOnClickModal: false
        }).then(async() => {
          this.polDetailValue.forEach(row => {
            if (row.uuid) {
              this.schemeCriteriaPolList.push({
                uuid: row.uuid,
                criteriaType: this.criteriaType,
                criteriaValue: row.criteriaValue,
                waitDealStatus: 'delete'
              })
            }
          })
          this.podDetailValue.forEach(row => {
            if (row.uuid) {
              this.schemeCriteriaPoDList.push({
                uuid: row.uuid,
                criteriaType: this.criteriaType,
                criteriaValue: row.criteriaValue,
                waitDealStatus: 'delete'
              })
            }
          })
          this.isNeedChangePort = true
        }).catch(() => {
          flag = true
        })
      }
      if (flag) {
        this.schemeMaintainForm.lob = this.previousValue
        return
      }
      this.previousValue = this.schemeMaintainForm.lob
      // 清空整拼类型
      this.schemeMaintainForm.containerLoadTypeArr = []
      this.convertTextFLCL()
      this.refreshCarrierCompanyList()
      // 判断是否清空承运人
      const company = this.carrierCompanyList.find(company => company.cmpIdx === this.schemeMaintainForm.carrierId)
      if (!company) {
        this.schemeMaintainForm.carrierId = null
      }
    },
    // 更新承运人数据源列表
    refreshCarrierCompanyList() {
      this.carrierCompanyList = this.allCompanyList.filter(company => {
        let result = true
        for (const key in this.carrierMethodParams) {
          result = result && company[key] === this.carrierMethodParams[key]
        }
        return result
      })
    },
    // 部门下拉框修改事件
    changeDepartment() {
      this.$nextTick(() => {
        this.convertTextDepartment()
      })
    },
    convertTextDepartment() {
      this.$nextTick(() => {
        const curSelect = this.$refs.departmentRef
        const selected = curSelect.selected.map(item => {
          return item.$el.innerText.trim()
        })
        const tagWrapper = curSelect.$el.querySelector('.el-select__tags>span')
        const childs = tagWrapper.childNodes
        if (childs.length > 1) {
          for (let i = 0; i < childs.length; ++i) {
            if (childs[i].className.includes('el-tag--info')) {
              childs[i].style.display = 'none'
            }
          }
          if (selected.length > 0) {
            if (childs[0].className !== '') {
              const newSpan = document.createElement('span')
              newSpan.innerText = `${selected.join(',')}`
              newSpan.title = `${selected.join(',')}`
              tagWrapper.insertBefore(newSpan, tagWrapper.childNodes[0])
            } else {
              childs[0].innerText = `${selected.join(',')}`
            }
          } else {
            tagWrapper.innerHTML = '<span></span>'
          }
        } else {
          tagWrapper.innerHTML = selected.length ? `<span>${selected.join(',')}</span>` : '<span></span>'
        }
        const parent = curSelect.$el.querySelector('.el-select__tags')
        parent.title = `${selected.join(',')}`
      })
    },
    // 整拼类型下拉框修改事件
    changeFLCL() {
      this.$nextTick(() => {
        this.convertTextFLCL()
      })
    },
    convertTextFLCL() {
      this.$nextTick(() => {
        const curSelect = this.$refs.FLclRef
        const selected = curSelect.selected.map(item => {
          return item.$el.innerText.trim()
        })
        const tagWrapper = curSelect.$el.querySelector('.el-select__tags>span')
        const childs = tagWrapper.childNodes
        if (childs.length > 1) {
          if (selected.length > 0) {
            if (childs[0].className !== '') {
              const newSpan = document.createElement('span')
              newSpan.innerText = `${selected.join(',')}`
              newSpan.title = `${selected.join(',')}`
              tagWrapper.insertBefore(newSpan, tagWrapper.childNodes[0])
            } else {
              childs[0].innerText = `${selected.join(',')}`
            }
          } else {
            tagWrapper.innerHTML = '<span></span>'
          }
          for (let i = 0; i < childs.length; ++i) {
            if (childs[i].className.includes('el-tag--info')) {
              childs[i].style.display = 'none'
            }
          }
        } else {
          tagWrapper.innerHTML = selected.length ? `<span>${selected.join(',')}</span>` : '<span></span>'
        }
        const parent = curSelect.$el.querySelector('.el-select__tags')
        parent.title = `${selected.join(',')}`
      })
    },
    async initBasicData() {
      const departmentList = await getSpecificBasicData(basicCacheKeys.basic_data_Department_All)
      if (departmentList && departmentList.length > 0) {
        this.allDepartments = departmentList.filter(p => p.officeUuid === this.$store.getters.currentOfficeUuid) || []
      } else {
        this.allDepartments = []
      }
      const companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
      if (companyList && companyList.length > 0) {
        if (this.$store.getters.currentOfficeId === 1) {
          this.allCompanyList = companyList.filter(p => p.branchId === 1) || []
        } else {
          this.allCompanyList = companyList.filter(p => p.branchId === 1 || p.branchId === this.$store.getters.currentOfficeId) || []
        }
      } else {
        this.allCompanyList = []
      }
      this.refreshCarrierCompanyList()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select{
  /deep/ .el-select__tags{
    & > span{
      width: 100%;
      box-sizing: border-box;
      padding-left: 10px;
      display: flex;
      span{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
